import * as dayjs from 'dayjs';
import icPowerPoint from 'assets/img/power_point.png';
import iCThetanCoin from 'assets/img/thetan_coin_V2.png';
import icThetanGem from 'assets/img/thetan_gem_V2.png';
import { CurrencyType, normalNumberToSystemCurrency } from '@wolffun/system-currency';
import { CurrencySymbol, InGameCurrency } from '../../config';
import { AppError } from '@profile/src/redux/types';
import { BN } from 'bn.js';
export const coinTypeMap = {
  [InGameCurrency.INGAME_THETAN_COIN]: {
    currencyFrom: 'THC',
    currencyTo: 'THC',
    nameFrom: 'Ingame Thetan Coin',
    nameTo: 'Thetan Coin',
    image: iCThetanCoin,
    toImage: icThetanGem,
    type: CurrencyType.GTHC
  },
  [InGameCurrency.INGAME_THETAN_GEM]: {
    currencyFrom: 'THG',
    currencyTo: 'THG',
    nameFrom: 'Ingame Thetan Gem',
    nameTo: 'Thetan Gem',
    image: icThetanGem,
    toImage: iCThetanCoin,
    type: CurrencyType.GTHG
  },
  [InGameCurrency.INGAME_POWER_POINT]: {
    nameFrom: 'Ingame Power Point',
    nameTo: 'Power Point',
    currencyFrom: 'PP',
    currencyTo: 'PP',
    toImage: icPowerPoint,
    image: icPowerPoint,
    type: CurrencyType.GPP
  }
};
export const getSystemCurrency = (ingameBalance, type) => {
  switch (type) {
    case InGameCurrency.INGAME_THETAN_COIN:
      return ingameBalance.balance[CurrencySymbol.INGAME_THETAN_COIN];

    case InGameCurrency.INGAME_THETAN_GEM:
      return ingameBalance.balance[CurrencySymbol.INGAME_THETAN_GEM];

    case InGameCurrency.INGAME_POWER_POINT:
      return ingameBalance.balance[CurrencySymbol.INGAME_POWER_POINT];

    default:
      throw new Error('Currency type missing');
  }
};
export const getUserCap = (ingameBalance, type) => {
  if (!ingameBalance.config || !ingameBalance.userCap) {
    return {
      totalClaimed: 0,
      lastTimeClaimed: 0,
      remainClaimTime: 0
    };
  }

  const {
    userCap: {
      lastTimeClaimedTHC,
      lastTimeClaimedTHG,
      totalTHCClaimed,
      totalTHGClaimed
    },
    config: {
      timeCapClaimedTHC,
      timeCapClaimedTHG
    }
  } = ingameBalance;
  const nowInSecond = Date.now() / 1000;

  switch (type) {
    case InGameCurrency.INGAME_THETAN_COIN:
      return {
        totalClaimed: totalTHCClaimed,
        lastTimeClaimed: lastTimeClaimedTHC,
        remainClaimTime: Math.max(timeCapClaimedTHC - Math.max(nowInSecond - lastTimeClaimedTHC, 0), 0)
      };

    case InGameCurrency.INGAME_THETAN_GEM:
      return {
        totalClaimed: totalTHGClaimed,
        lastTimeClaimed: lastTimeClaimedTHG,
        remainClaimTime: Math.max(timeCapClaimedTHG - Math.max(Date.now() / 1000 - lastTimeClaimedTHG, 0), 0)
      };

    default:
      return {
        totalClaimed: 0,
        lastTimeClaimed: 0,
        remainClaimTime: 0
      };
  }
};
export function formatErrorMessage(error, arg) {
  switch (error) {
    case AppError.UNNKOWN:
      return 'Something went wrong.\nPlease try again later.';

    case AppError.QUOTE_EXPIRED:
      return `Quote expired! Please refresh for a new one`;

    case AppError.MINIMUN_CASHOUT:
      return `Min convertable: ${arg === null || arg === void 0 ? void 0 : arg.minConvertable} ${arg === null || arg === void 0 ? void 0 : arg.unit}`;

    case AppError.MAXIMUN_CASHOUT:
      return `Max convertable: ${arg === null || arg === void 0 ? void 0 : arg.maxConvertable} ${arg === null || arg === void 0 ? void 0 : arg.unit}`;

    case AppError.NOT_RANK_ENOUGH_CASHOUT:
      return 'Reach rank Bronze 1 to start claiming your token';

    case AppError.NOT_OLD_ENOUGH_CASHOUT:
      return `Start claiming your token after: ${arg === null || arg === void 0 ? void 0 : arg.cashOutDate}`;

    case AppError.WRONG_PRICE:
      return 'Only support data claim type THC (or THG) for claim THC (or THG)';

    case AppError.WRONG_FORMAT:
      return 'Data input wrong format';

    case AppError.USER_NOT_FOUND:
      return 'User not found - something when wrong with accesstoken';

    case AppError.USER_BANNED:
      return 'Account banned';

    case AppError.ADDRESS_INVALID:
      return 'Address is empty';

    case AppError.CAN_NOT_CLAIM:
      return 'Cannot cash out at this time';

    case AppError.NOT_ENOUGH_GTHC:
      return 'Insufficient THC balance';

    case AppError.NOT_ENOUGH_GTHG:
      return 'Insufficient THG balance';

    case AppError.NOT_ENOUGH_FEE_GTHG:
      return 'Insufficient THG! Please deposit to proceed.';

    case AppError.INVALID_GTHG:
      return 'Invalid THG balance!';

    case AppError.OUT_OF_LIMIT_CASHOUT:
      return 'Input amount out of range min max cash out';

    default:
      return 'Something error happened try again later';
  }
}
export const checkOverPriceError = (coinType, price, currentBalance) => {
  if (!currentBalance) return AppError.NO_ERROR;
  const priceCurrency = normalNumberToSystemCurrency(price, currentBalance.token);
  const priceBN = new BN(priceCurrency.value);
  const balanceBN = new BN(currentBalance.value);
  if (priceBN.gt(balanceBN)) switch (coinType) {
    case InGameCurrency.INGAME_THETAN_COIN:
      return AppError.NOT_ENOUGH_THC;

    case InGameCurrency.INGAME_THETAN_GEM:
      return AppError.NOT_ENOUGH_THG;

    case InGameCurrency.INGAME_POWER_POINT:
      return AppError.NOT_ENOUGH_PP;

    default:
      return AppError.UNNKOWN;
  } else return AppError.NO_ERROR;
};
export const getNotOldErrorMessage = (profile, remainTime) => {
  const createdFrom = dayjs(profile.created);
  const validDate = dayjs().subtract(remainTime, 'seconds');
  const duration = dayjs.duration(createdFrom.diff(validDate));
  return duration.format('DD [days] HH [hours] mm [minutes]');
};